import { makeVar } from '@apollo/client'

/**
 * An array made up of ids of the selected stations and/or groups
 *
 * @example
 * ['stat-123', 'group-123']
 */
const stationsVar = makeVar([])

/**
 * An array of the selected fuel grade titles
 *
 * @example
 * ['87', '89', 'Diesel']
 */
const fuelGradesVar = makeVar([])

/**
 * An object of the selected period as an object of two Moment objects
 *
 * @example
 * { from: Moment, to: Moment }
 */
const periodVar = makeVar(null)

/**
 * An array of the selected pole price audit price change statuses
 *
 * @example
 * ['awaiting_detection', 'completed', 'cma_submission_not_compliant']
 */
const statusesVar = makeVar([])

export {
  stationsVar,
  fuelGradesVar,
  periodVar,
  statusesVar,
}